import React from "react";
import Card from "@/component/card";
import Carousel from "@/bit/components/components.carousel";

const createAhorroLabel = (cardData) => {
  const res = cardData;
  const { originalPrice, monthlyPayment } = cardData;
  const r2rPrice = cardData["Price-2"]?.amount;
  if (r2rPrice && originalPrice && monthlyPayment) {
    const ahorro =
      parseFloat(monthlyPayment) * parseFloat(r2rPrice) -
      parseFloat(originalPrice) +
      1;
    if (ahorro < -10) {
      const normalizedSavingForLabel = Number.isInteger(ahorro) ?
        ahorro :
        ahorro?.toFixed(2)?.replace(".", ",");
      res["Label-2"] = {
        label: `${normalizedSavingForLabel}€ vs. libre`,
        theme: "discount",
        inversed: false,
        notBorderRadius: true,
      };
    }
  }
  return res;
};

const DevicesCarousel = (dispoData) => {
  const { taggingInfo } = dispoData;
  const deviceItems = Object.keys(dispoData).filter((key) =>
    key.startsWith("Device")
  );
  if (deviceItems) {
    return (
      <div className="device-content container">
        <Carousel slideSeparation={12} className="DeviceOffers" maxPointNum={0}>
          {deviceItems &&
            Array.isArray(deviceItems) &&
            deviceItems.map((e, i) => {
              const labelAhorro = createAhorroLabel(dispoData[e]);

              return (
                <div className="device-slide" key={`slide-${i}`}>
                  <Card
                    taggingInfo={taggingInfo}
                    {...{ ...dispoData[e], ...labelAhorro }}
                    imageClassName="aspect-ratio-4-5"
                    skeletonClassName={dispoData?.skeletonClassName}
                    finalFetch={dispoData?.finalFetch}
                  ></Card>
                </div>
              );
            })}
        </Carousel>
      </div>
    );
  }
  return null;
};

export default DevicesCarousel;
